import React from "react";
import dayjs from "dayjs";
import { deleteNotification } from "../../../../api/system/notifications";
import { showSuccessToast, showErrorToast } from "../../../../components/ConfirmDialog";
import { confirmDelete, DELETE_ENTITY } from "../../../../utils/confirmDelete";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTrash } from "@fortawesome/free-solid-svg-icons";

export default function NotificationViewModal({ item, onClose, onDeleted }) {
  if (!item) return null;

  const handleDelete = async () => {
    const cf = await confirmDelete({
      type: DELETE_ENTITY.notification,
      name: item?.title,
    });

    if (!cf.isConfirmed) return;

    try {
      await deleteNotification(item.id);
      showSuccessToast("Đã xóa thông báo!");
      onDeleted?.();     // refresh list
      onClose();         // close popup
    } catch (err) {
      showErrorToast("Không thể xóa thông báo");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[420px] shadow-xl animate-fadeIn relative">

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-red-600"
        >
          <FontAwesomeIcon icon={faXmark} size="lg" />
        </button>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-800 pr-8">
          {item.title}
        </h2>

        {/* Category */}
        <div className="mt-3">
          <span className="px-2 py-1 bg-gray-100 rounded text-sm text-gray-700">
            {item.category || "Không phân loại"}
          </span>
        </div>

        {/* Info */}
        <div className="mt-4 text-sm text-gray-600 space-y-1">
          <div>
            <span className="font-medium">Người gửi:</span>{" "}
            {item.sender_name || "Không rõ"}
          </div>

          {/* Người nhận (nhiều) */}
          {item.receivers && item.receivers.length > 0 && (
            <div>
              <span className="font-medium">Người nhận:</span>{" "}
              {item.receivers.map((r) => r.name).join(", ")}
            </div>
          )}

          <div>
            <span className="font-medium">Thời gian:</span>{" "}
            {dayjs(item.created_at).format("DD/MM/YYYY HH:mm")}
          </div>
        </div>

        {/* Message content */}
        <div className="mt-5 border-t pt-4">
          <p className="text-gray-800 leading-relaxed whitespace-pre-line">
            {item.message}
          </p>
        </div>

        {/* Delete button */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faTrash} />
            Xóa thông báo
          </button>
        </div>
      </div>
    </div>
  );
}
